import utils from 'utils';

'use strict';

/* SET GLOBAL VARS */
utils.setCurrentLang();
window.mq = utils.mq;

/*GLOBAL TRIGGERING */
if (document.querySelector('#minisite-header')) {
  utils.vars.minisiteHeaderHeight();
} else {
  utils.vars.headerHeight();
}
utils.vars.searchEngineHeight();
utils.vars.headerSearchHeight();
utils.vars.regionListWrapperWidth();

// sticky elems
const stickyElems = document.querySelectorAll('.js-sticky');
stickyElems.forEach(stickyElem => {
  const stickyReference = stickyElem.getAttribute('data-sticky-reference');
  utils.isSticky(stickyElem, 'active', stickyReference)
});


// // toogleClass

// document.querySelectorAll('.js-toggle').forEach(elem => {
//   console.log('elem',elem)
//   utils.toggleClass(elem)
// })


// utils.isInViewport(document.querySelector('.search-engine'), e => {
//   console.log(e, e.isIntersecting)
//   if (e.isIntersecting) {
//   } else {
//   }
// })
